/* eslint-disable @typescript-eslint/naming-convention */
import { EquipmentUsageDetailDto } from './EquipmentUsageDetailDto';

export class EquipmentUsageDto {
  public AltID: string;
  public BillingRate: number;
  public BillingTemplate: string;
  /** Client-only: true when BillingRate was filled from dispatch for display but is not saved on the usage record. */
  public BillingRateNotPersisted?: boolean;
  /** Client-only (WI 30926): the save gate found no rate under the job's template; shows the clickable Bill As warning. */
  public BillAsSelectionRequired?: boolean;
  public Details: EquipmentUsageDetailDto[];
  public Equipment: string;
  public EquipmentName: string;
  public EquipmentBillingID: string;
  public EquipmentDispatchID: string;
  public EquipmentID: string;
  public Shift: number;
  public UnitName: string;
  public WorkOrder: string;
  public CustomerPO: string;
  public bActive: boolean;
  JobID?: string;
  WorkOrderDescription?: string;
  IsContractActiveWorkOrder?: boolean;
  DispatchStartDate?: Date;
  DispatchEndDate?: Date;
  TotalAmount?: number;
}
